export default "__VITE_ASSET__DLe2WBC5__"